// composables/useEnhancedI18n.ts

import vueUseI18n from './useI18n'
import { computed, WritableComputedRef } from 'vue'
import { useStore } from 'vuex'
import { ComposerTranslation } from 'vue-i18n'
import store from "@/store";

interface UseI18nReturn {
  t: (key: string) => string;
  locale: WritableComputedRef<string>;
  originalT?: ComposerTranslation;
  switchLanguage: (lang: string) => Promise<void>;
}


export function useI18n({useScope='global'} : { useScope?: any }={}): UseI18nReturn {
  // 使用原有的 vue-i18n
  const { t: originalT, locale } = vueUseI18n({ useScope })
  const store = useStore()
  // 获取动态处理后的文本
  const dynamicT = computed(() => store.getters['i18n/t'])

  // 检查是否已完成动态初始化
  const isDynamicInitialized = computed(() => store.state.i18n?.isInitialized)

  // 处理文本
  const enhancedT = (key: string): string => {
    // 如果key没有.，则认为是不需要转换的 或者是普通文本 直接返回原始文本
    if(key.indexOf(".")==-1){
      return originalT(key);
    }
    // 如果动态配置已初始化，优先使用动态处理后的文本
    if (isDynamicInitialized.value) {
      let resultText = dynamicT.value(key,originalT)
      //console.log(">>>>>>请求的key",key,"返回的文本",resultText)
      return resultText
    }
    // 否则使用原始的 vue-i18n
    let originText = originalT(key);
    //console.log(">>>>>>请求的key",key,"返回的originText",originText)
    return originText
  }

  // 全局语言切换方法
  const switchLanguage = async (lang: string) => {
    // 更新vue-i18n的语言
    locale.value = lang;

    // 更新store中的语言设置
    store.commit('SET_LANGUAGE', lang);

    // 重新初始化动态国际化配置
    await store.dispatch('i18n/initializeDynamicI18n', {
      baseLocalText: store.getters['i18n/baseMessages'](lang),
      userConfig: store.state.i18n?.aliasConfigs || []
    });
  };

  return {
    t: enhancedT,
    locale,
    originalT, // 保留原始方法以备不时之需
    switchLanguage
  }
}
